/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=2fa066c2&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"
import style0 from "./wallet.vue?vue&type=style&index=0&id=2fa066c2&prod&lang=scss"
import style1 from "./wallet.vue?vue&type=style&index=1&id=2fa066c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa066c2",
  null
  
)

export default component.exports